import React from 'react'
import {SerializedError} from '@reduxjs/toolkit'
import {FetchBaseQueryError} from '@reduxjs/toolkit/query'
import {getRTKError} from '../../utils/helpers'
import CustomAlert from '../CustomAlert'

interface CustomErrorAlert {
  error?: FetchBaseQueryError | SerializedError
  show: boolean
  className?: string
  close?: () => void
}
export const CustomErrorAlert = ({error, show, className, close}: CustomErrorAlert) => {
  const rtkError = getRTKError(error)
  return (
    <CustomAlert
      title={rtkError.title}
      text={rtkError.description}
      show={show}
      className={className}
      variant='danger'
      close={close}
    />
  )
}
